<template>
  <div>
    <div class="mb-4">
      <h6 class="font-weight-bold">Quando quer receber o pedido?</h6>
      <aviso-informativo variante="vermelho" :mostrar-icone="false" class="small mb-2" v-if="alerta">
        Selecione se deseja pedir agora ou agendar seu pedido.
      </aviso-informativo>
      <div class="row no-gutters">
        <div class="col-6 pr-1" v-if="empresa.aberto === '1'">
          <a href="javascript:" class="text-dark text-decoration-none" @click="changeHorario(null)">
            <div class="card card-horario card-border" :class="{'active': selecionado && !dados.id_entrega}" aria-hidden="true">
              <div class="card-body d-flex align-items-center">
                <div>
                  <b>Pedir agora</b>
                  <div class="small">Padrão</div>
                </div>
                <div class="text-right pl-2" style="margin-left: auto">
                  <indicador-selecao :selecionado="!!selecionado && !dados.id_entrega"/>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div class="col-6" :class="{'pl-1': empresa.aberto === '1'}">
          <a href="javascript:" class="text-dark text-decoration-none" @click="selAgendar()">
            <div class="card card-horario card-border" :class="{'active': dados.id_entrega}" aria-hidden="true">
              <div class="card-body d-flex align-items-center">
                <div>
                  <b>{{agendamento && dados.id_entrega ? (agendamento.data_formatada || 'Hoje') : 'Agendar'}}</b>
                  <div class="small" v-if="agendamento && dados.id_entrega">{{agendamento.horario_inicio}} - {{agendamento.horario_fim}}</div>
                  <div class="small" v-else>Selecionar {{agendamento_maximo ? 'data' : 'horário'}}</div>
                </div>
                <div class="text-right pl-2" style="margin-left: auto">
                  <indicador-selecao :selecionado="!!dados.id_entrega"/>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div id="modalAgendamento" class="modal-agendamento" v-show="opened">
      <div class="modal-agendamento-content modal-rounded-scroll">
        <top-bar title="Agendar pedido" event="true" :fixo="false" class="mb-3" @voltar="closeModal"/>
        <div class="container mb-4">
          <div v-if="agendamento_maximo && dias.length">
            <div class="mb-3">
              <label class="font-weight-bold m-0 small">Escolha um dia</label>
              <select class="form-control" v-model="dia" @change="changeDia()">
                <option :value="null" v-if="hoje_disponivel">Hoje</option>
                <option :value="d" v-for="d in dias">{{ d.dataFormatada }}</option>
              </select>
            </div>
          </div>
          <h6 class="mt-1">Selecione um horário</h6>
          <div v-if="horarios.length">
            <div class="row no-gutters">
              <div class="col-6 px-1" v-for="(h, index) in horarios" :key="index">
                <a href="javascript:" class="text-dark text-decoration-none" @click="changeHorario(h)">
                  <div class="card card-horario card-border mb-3" :class="{'active': h.id_entrega === dados.id_entrega}" aria-hidden="true">
                    <div class="card-body d-flex align-items-center">
                      <div>
                        <div class="small text-primary">{{ dia ? dia.dataFormatada : 'Hoje' }}</div>
                        <b>{{h.horario_inicio}} - {{h.horario_fim}}</b>
                      </div>
                      <div class="text-right pl-2" style="margin-left: auto">
                        <indicador-selecao :selecionado="dados.id_entrega === h.id_entrega"/>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <aviso-informativo variante="amarelo" class="small mb-0" v-else>
            Data indisponível para agendamento.
          </aviso-informativo>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AvisoInformativo from "./AvisoInformativo";
  import TopBar from './TopBar';
  import IndicadorSelecao from './IndicadorSelecao';

  export default {
    name: "ModalAgendamento",
    components: {AvisoInformativo, TopBar, IndicadorSelecao},
    props: ['dados', 'agendamento', 'selecionado', 'alerta'],
    data () {
      return {
        opened: false,
        finalizar: false,
        agendar: false,
        horarios: [],

        dias: [],
        agendamento_maximo: 0,
        prazo_minimo: 0,
        mesmo_dia: true,
        hoje_disponivel: false,
        horario: '',
        dia: null
      }
    },

    methods: {
      openModal() {
        document.body.classList.add("modal-open");
        this.opened = true;
        const configAgendamento = this.empresa.agendamento_config || {};
        this.agendamento_maximo = parseInt(configAgendamento.prazo_maximo || '0');
        this.prazo_minimo = parseInt(configAgendamento.prazo_minimo || '0');
        this.mesmo_dia = String(configAgendamento.mesmo_dia === undefined ? '1' : configAgendamento.mesmo_dia) === '1';
        this.agendar = !!this.dados.id_entrega;
        this.dia = null;
        this.getDias();

        if (this.dados.dia_agendamento) {
          this.dia = this.dias.find(d => this.dados.dia_agendamento === d.date) || null;
        }

        if (!this.dia && !this.hoje_disponivel) {
          this.dia = this.dias[0] || null;
        }

        this.changeDia();
      },

      closeModal() {
        this.finalizar = false;
        document.body.classList.remove("modal-open");
        this.opened = false;
      },

      changeHorario(h) {
        this.agendar = false;

        if (this.dia && h) {
          h.dia_agendamento = this.dia.date;
          h.data_formatada = this.dia.dataFormatada;
        }

        this.$emit('changeHorario', h, this.finalizar);

        if (h) {
          this.closeModal();
        }
      },

      getDias() {
        const agora = new Date();
        const dias = [];
        const diasSemana = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

        this.hoje_disponivel = this.mesmo_dia && this.horariosPorData(agora).length > 0;

        for (let i = 0; i < this.agendamento_maximo; i++) {
          const proximoDia = new Date(agora);
          proximoDia.setDate(agora.getDate() + (i + 1));
          const dia = String(proximoDia.getDate()).padStart(2, '0');
          const mes = String(proximoDia.getMonth() + 1).padStart(2, '0');
          const ano = proximoDia.getFullYear();
          const semana = proximoDia.getDay();
          const dataFormatada = `${diasSemana[semana]} - ${dia}/${mes}`;
          const data = { date: `${ano}-${mes}-${dia}`, dataFormatada, semana: (semana + 1) };

          if (this.horariosPorData(proximoDia).length) {
            dias.push(data);
          }
        }

        this.dias = dias;
      },

      changeDia() {
        this.horarios = [];

        if (!this.dia) {
          if (!this.mesmo_dia) {
            return;
          }

          this.horarios = this.horariosPorData(new Date());
          return;
        }

        const dataSelecionada = this.dataPorString(this.dia.date);
        this.horarios = this.horariosPorData(dataSelecionada);
      },

      horariosPorData(data) {
        const semana = data.getDay() + 1;
        return (this.empresa.agendamentos || []).filter(item => item.dia == semana && this.horarioDisponivel(item, data));
      },

      horarioDisponivel(horario, data) {
        const partes = String(horario.horario_inicio || '').split(':');

        if (partes.length < 2) {
          return false;
        }

        const dataHorario = new Date(data);
        dataHorario.setHours(parseInt(partes[0], 10), parseInt(partes[1], 10), 0, 0);
        const limite = new Date();
        limite.setMinutes(limite.getMinutes() + this.antecedenciaMinimaMinutos());
        return dataHorario > limite;
      },

      antecedenciaMinimaMinutos() {
        if (this.prazo_minimo > 0) {
          return this.prazo_minimo * 60;
        }

        if (parseInt(this.dados.tipo_pedido) === 1) {
          const usuario = this.$store.state.dataUser || {};
          const tempoEndereco = this.dados.zona && this.dados.zona.tempo_entrega
            ? this.dados.zona.tempo_entrega
            : usuario.tempo_entrega;
          return parseInt(tempoEndereco || this.empresa.media_entrega || '0');
        }

        return parseInt(this.empresa.media_retirada || '0');
      },

      dataPorString(data) {
        const partes = String(data).split('-');
        return new Date(parseInt(partes[0], 10), parseInt(partes[1], 10) - 1, parseInt(partes[2], 10));
      },

      selAgendar() {
        this.agendar = true;
        this.dia = null;
        this.changeDia();
        this.openModal();
      }
    },

    created() {
      this.$parent.$on('openModalHorario', (finalizar) => {
        this.finalizar = !!finalizar;
        this.openModal();
      });
    },

    computed: {
      empresa() {
        return this.$store.state.empresa;
      }
    }
  }
</script>

<style scoped>
  .card-horario {
    height: 90px;
  }

  .modal-agendamento .card-horario {
    border: 1px solid #e3e6e9;
    box-shadow: none;
  }

  .modal-agendamento {
    display: block;
    position: fixed; /* Stay in place */
    z-index: 1040; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  .modal-agendamento-content {
    background-color: #fefefe;
    overflow: auto;
    margin: 48px auto;
    width: 500px;
    height: 75vh;
    position: relative;
    border-radius: 12px;
  }

  @media (max-width: 600px) {
    .modal-agendamento-content {
      overflow: auto;
      min-height: 100%;
      height: 100vh;
      width: 100%;
      margin: 0;
      border-radius: 0;
      clip-path: none;
    }
  }

  .card-horario.active {
    justify-content: normal!important;
    color: var(--lecard-primary);
    border: 2px solid var(--lecard-primary);
  }
</style>
